import React, { Component } from "react"
import Icon from "../../artzu-ui/src/Icon"
import { m } from '../../utils';
import './index.css'

class PriceMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { 
      startDate,
      navigateWeek,
      stretch,
      pMap
    } = this.props;
    return (
      <div className="week-nav">
        <p className="month-display">{startDate.format("MMMM YYYY")}</p>
        <div className="week-slide">
          {startDate.isAfter(m().clone().startOf("isoWeek").subtract(1, "week")) ? 
          <a
            href=""
            className="week-chevron" 
            onClick={e => {
              e.preventDefault();
              navigateWeek("prev");
          }}>
            <Icon name="ChevronLeft" size="sm" />
          </a> : 
          <a
            href=""
            className="week-chevron"
            onClick={e => e.preventDefault()}>
            <Icon name="ChevronLeft" size="sm" color="#dedede" />
          </a>}
          <div className="week-cluster">
            {pMap.map(day => {
              let weekday = m(day.date).format("dd");
              let date = m(day.date).format("D");
              let color = m(day.date).isSame(m(), 'day') ? "#128dff" : (m(day.date).isBefore(m(), 'day') ? "#dedede" : "#414141");
              return (
                <div className="weekday-container" style={{color}}>
                  <p>{weekday[0]}</p>
                  <p>{date}</p>
                </div>
              )
            })}
          </div>
          <a
            href=""
            className="week-chevron" 
            onClick={e => {
              e.preventDefault();
              navigateWeek("next");
          }}>
            <Icon name="ChevronRight" size="sm" />
          </a>
        </div>
      </div>
    )
  }
}

export default PriceMap;


// WEBPACK FOOTER //
// ./src/components/PriceMap/WeekNavigator.js